import React, {memo, useEffect, useState} from "react";
import EmbeddedPayment from "../../../../components/DocumentGeneration/components/EmbeddedPayment/EmbeddedPayment";
import { HttpService } from "../../../../services/HttpService";

type Props = {
    uuid: string;
    handlePreviousStep: () => void;
}

function Payment(props: Props): React.ReactElement {
    const {
        uuid,
        handlePreviousStep,
    } = props;

    const [showModal, setShowModal] = useState<boolean>(false);
    const [clientSecret, setClientSecret] = useState<string>();

    useEffect(() => {
        HttpService.get(
            `/api/checkout/create-session/${uuid}/return-shipment`
        ).then(res => {
            const {clientSecret} = res.data.embeddedData;
            setClientSecret(clientSecret);
            setShowModal(true);
        });

        return () => {
            setShowModal(false);
            setClientSecret(undefined);
        }
    }, [uuid]);

    return (
        <div className="w-full">
            {
                (clientSecret && showModal) ? (
                    <EmbeddedPayment clientSecret={clientSecret} onClose={handlePreviousStep}/>
                ) : null
            }
        </div>
    )
}

export default memo(Payment);